<script setup lang="ts">
withDefaults(defineProps<{
  eyebrow?: string
  title: string
  description?: string
  align?: 'left' | 'center'
  inverse?: boolean
}>(), {
  eyebrow: undefined,
  description: undefined,
  align: 'center',
  inverse: false,
})
</script>

<template>
  <div :class="['max-w-3xl', align === 'center' ? 'mx-auto text-center' : 'text-left']">
    <p
      v-if="eyebrow"
      :class="['mb-4 inline-flex items-center gap-2 text-sm font-semibold', inverse ? 'text-sky-blue-200' : 'text-sky-blue-700']"
    >
      <span :class="['h-px w-6', inverse ? 'bg-sky-blue-300/70' : 'bg-sky-blue-400']" aria-hidden="true" />
      {{ eyebrow }}
    </p>
    <h2 :class="['text-balance text-3xl font-bold tracking-[-0.025em] sm:text-4xl lg:text-[2.75rem] lg:leading-tight', inverse ? 'text-white' : 'text-slate-950']">
      {{ title }}
    </h2>
    <p v-if="description" :class="['mt-5 text-pretty text-base leading-7 sm:text-lg', inverse ? 'text-sky-blue-100' : 'text-slate-600']">
      {{ description }}
    </p>
  </div>
</template>
